import { render, staticRenderFns } from "./CircuitBreaker.vue?vue&type=template&id=52a37ae5&scoped=true"
import script from "./CircuitBreaker.vue?vue&type=script&lang=js"
export * from "./CircuitBreaker.vue?vue&type=script&lang=js"
import style0 from "./CircuitBreaker.vue?vue&type=style&index=0&id=52a37ae5&prod&scoped=true&lang=css"
import style1 from "./CircuitBreaker.vue?vue&type=style&index=1&id=52a37ae5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a37ae5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VLayout,VProgressLinear})
